module.exports = __webpack_public_path__ + "static/media/mogugori-logo.c9edc64f.png";